export const encodeSlash = (url: string) => {
    return url.replace('/', '%2F');
};
